import { render } from "./add_card.vue?vue&type=template&id=6c50f6b7"
import script from "./add_card.vue?vue&type=script&lang=js"
export * from "./add_card.vue?vue&type=script&lang=js"

import "./add_card.vue?vue&type=style&index=0&id=6c50f6b7&lang=css"

import exportComponent from "D:\\SchoolManagement-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__